/**
 * SHARED — where the legal documents live, and the one place that decides it.
 *
 * The Terms open with "By creating an account, starting a trial, or using Brand
 * Command, you agree to them." Until 2026-08-05 the app never showed or linked
 * either document — a grep of all of `app/src` for `terms|privacy` returned four
 * hits and not one was a link. That made the acceptance clause a claim about a
 * page the user had never seen and could not reach from the product.
 *
 * ⚠️ POINT AT THE STATIC PAGES (`/terms.html`, `/privacy.html`), NOT the
 * directory forms `/terms/` and `/privacy/`. Those are the campaign-era React
 * copies; website item 45(f) turns them into 301s and deletes them at launch, so
 * linking them here would age into a redirect chain the day the site ships.
 *
 * ⚠️ These pages are NOT live yet — brandcommand.app is still the coming-soon
 * placeholder, so both 404 until the marketing site launches (website item 23).
 * That is deliberate and is still better than the alternative: the links are
 * correct the moment the site ships, and shipping the app with no reference to
 * its own terms at all was the actual defect.
 */

/** Marketing site origin. Override for a local site preview. */
export const MARKETING_URL = (
  import.meta.env.VITE_MARKETING_URL || "https://brandcommand.app"
).replace(/\/+$/, "");

export const TERMS_URL   = `${MARKETING_URL}/terms.html`;
export const PRIVACY_URL = `${MARKETING_URL}/privacy.html`;

/** Props every legal link needs: new tab, and no window.opener handback. */
export const LEGAL_LINK_PROPS = { target: "_blank", rel: "noopener noreferrer" };
